
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        var mod = require("D:\\dev\\CAMSCON_v05_2020\\pages\\index.js");
        if (true && module.hot) {
          module.hot.accept("D:\\dev\\CAMSCON_v05_2020\\pages\\index.js", function () {
            if (!next.router.components["/"]) return;
            var updatedPage = require("D:\\dev\\CAMSCON_v05_2020\\pages\\index.js");
            next.router.update("/", updatedPage);
          });
        }
        return mod;
      }
    ]);
  